// src/components/PeoplePlan/TheBench/components/WorkflowControls/ViewToggleButton.js
import React from "react";

const ViewToggleButton = ({ viewMode, onToggle }) => {
  return (
    <button className="bench-view-toggle" onClick={onToggle}>
      {viewMode === "table" 
        ? "Switch to Kanban View" 
        : "Switch to Table View"}
    </button>
  );
};

export default ViewToggleButton;